
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import PropTypes from 'prop-types';

function LiveGameTimeline (props) {
    return Template.default.apply({props}); //eslint-disable-line no-undef
}

LiveGameTimeline.propTypes = {
    game: PropTypes.object.isRequired,
    sportAlias: PropTypes.string.isRequired
};

export default LiveGameTimeline;